import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { Button } from '@/components/ui/button'
import { useTranslation } from '../../../lib/locales'
import { LanguagesIcon } from 'lucide-react'
import { useLingui } from '@lingui/react/macro'

export function LanguageSelector() {
  const { t } = useLingui()
  const { language, changeLanguage, languages } = useTranslation()

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        render={
          <Button variant="outline">
            <LanguagesIcon />
            {languages[language]}
          </Button>
        }
      />
      <DropdownMenuContent align="end">
        {/* The label belongs INSIDE the radio group: Base UI's GroupLabel reads MenuGroupContext to wire
            itself up as the group's accessible name, and throws when rendered as a sibling — which took
            the whole menu down through the nearest CatchBoundary. */}
        <DropdownMenuRadioGroup value={language} onValueChange={changeLanguage}>
          <DropdownMenuLabel>{t`Select a Language`}</DropdownMenuLabel>
          {Object.entries(languages).map(([code, label]) => (
            <DropdownMenuRadioItem key={code} value={code}>
              {label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
